import { Platform } from 'react-native';

/** Bundled for native and local web dev (Expo webpack). */
export const GRADING_TILE_IMAGE_LOCAL = require('../../assets/ChatGPT Image Jan 28, 2026, 12_32_42 AM.png');

/**
 * Served from Vercel `web-build/` root (`public/grading-tile.png` copied at build time).
 * Same artwork as assets/ChatGPT Image Jan 28, 2026, 12_32_42 AM.png
 */
export const GRADING_TILE_STATIC_WEB_PATH = '/grading-tile.png';

/** `{ imageLocal }` or `{ imageUrl }` for tile components. */
export function getGradingTileImageSource() {
  if (Platform.OS === 'web' && process.env.NODE_ENV === 'production') {
    return { imageUrl: GRADING_TILE_STATIC_WEB_PATH };
  }
  return { imageLocal: GRADING_TILE_IMAGE_LOCAL };
}
